export default "__VITE_ASSET__CXL4AA3f__"